import { render } from "../../_id/_id.html?vue&type=template&id=500cbbf1&ts=true"
import script from "./_id.vue?vue&type=script&lang=ts"
export * from "./_id.vue?vue&type=script&lang=ts"

import "../../_id/_id.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__